import React, { Component } from 'react'
import { func, bool } from 'prop-types'
import Modal from 'react-modal'
import { translate } from 'react-i18next'
import { Input } from '../ui/inputs/Input'
import api from '../../api'
import { stores, view } from '../../stores'
import { getErrorTranslation } from '../../utilities/errors'

class PasswordConfirmationModalComponent extends Component {
  constructor () {
    super()
    this.state = {
      password: '',
      error: ''
    }
  }

  validate () {
    const { t } = this.props
    const isValid = this.state.password && this.state.password !== ''
    if (!isValid) {
      this.setState({ error: t('common:fields:mandatory_value') })
    } else {
      this.setState({ error: '' })
    }
    return isValid
  }

  update ({ password }) {
    this.setState({ error: '', password })
  }

  async submit () {
    const { t } = this.props
    try {
      await api.authentication.authenticate({
        email: stores.account.connected.email,
        password: this.state.password,
        type: 'password'
      })
      this.props.onAuthenticated(this.state.password)
      this.props.handleClose()
    } catch (e) {
      this.setState({ error: getErrorTranslation(t, e) })
    }
  }

  render () {
    const { t, handleClose, isOpen } = this.props
    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={handleClose}
        contentLabel='Minimal Modal Example'
        className='modal modal--auto'
        overlayClassName='signup_overlay'>
        <span onClick={handleClose} style={{cursor: 'pointer'}} className='ReactModal__close'><img src='/app/images/close.png' alt='' /></span>
        <p>{t('common:account:password_confirmation')}</p>
        {
          this.state.error !== ''
          ? <p className='form__errormessage'>{this.state.error}</p>
          : ''
        }
        <Input value={this.state.password} onChange={(password) => this.update({ password })} ref='password' label={t('common:fields:actualPassword')} name='password' type='password' />
        <button style={{ clear: 'both' }} onClick={() => this.validate() && this.submit()} className='btn--default btn--small layout--centered'>{t('common:buttons:confirm')}</button>
      </Modal>
    )
  }
}

PasswordConfirmationModalComponent.propTypes = {
  t: func,
  isOpen: bool,
  handleClose: func,
  onAuthenticated: func
}

export const PasswordConfirmationModal = translate()(view(PasswordConfirmationModalComponent))

/* import Input from '../../General/Form/Input'
import { getErrorType } from '../../../utilities'

class ModalConfirmWithPassword extends Component {
  constructor () {
    super()

    this.state = {
      showModal: false,
      errorMessage: ''
    }

    this.handleOpenModal = this.handleOpenModal.bind(this)
    this.handleCloseModal = this.handleCloseModal.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  /*
   * Handle the opening of the modal

  handleOpenModal () {
    this.setState({showModal: true})
  }

  /*
   * Handle the closing of the modal

  handleCloseModal () {
    this.props.handleClose()
    this.setState({showModal: false})
  }

  componentWillReceiveProps (nextProps) {
    this.setState({showModal: nextProps.isModalOpened})
  }

  handleSubmit () {
    const password = this.refs.password.state.value
    this.props.auth.login(this.props.email, password)
      .then((response) => {
        if (response.status === 200) {
          return this.props.handleSubmit(password)
        }
        const type = getErrorType(response)
        this.setState({ errorMessage: this.props.t('common:api:errors:' + type) })
      })
  }

  render () {
    const { t } = this.props
    return (
      <div>
        <Modal
          isOpen={this.state.showModal}
          onRequestClose={this.handleCloseModal}
          contentLabel='Minimal Modal Example'
          className='modal modal--auto'
          overlayClassName='signup_overlay'
        >
          <span onClick={this.handleCloseModal} style={{cursor: 'pointer'}} className='ReactModal__close'><img src='/app/images/close.png' alt='' /></span>
          <p>{t('common:account:password_confirmation')}</p>
          {this.state.errorMessage !== '' &&
            <p className='form__errormessage'>{this.state.errorMessage}</p>
          }
          <Input ref='password' label={t('common:fields:actualPassword')} name='password' type='password' />
          <button style={{clear: 'both'}} onClick={this.handleSubmit} className='btn--default btn--small layout--centered'>{t('common:buttons:confirm')}</button>
        </Modal>
      </div>
    )
  }
}
const { bool, func } = PropTypes
ModalConfirmWithPassword.propTypes = {
  isModalOpened: bool,
  handleClose: func,
  t: func,
  handleSubmit: func
}

ModalConfirmWithPassword.defaultProps = {
  isModalOpened: false
}

export default translate()(ModalConfirmWithPassword) */



// WEBPACK FOOTER //
// ./src/components/modals/PasswordConfirmationModal.js